export const roundAmount = (amount: number | string, decimals = 2): number => {
  const numValue = typeof amount === 'string' ? Number(amount) : amount

  const factor = Math.pow(10, decimals)
  // Snap IEEE-754 dust before truncating: 4.1 * 100 === 409.99999999999994,
  // so a bare Math.trunc would eat a real cent (4.10 → 4.09). 15 significant
  // digits sits far above float dust (~1e-16 relative) yet far below any
  // genuine wire-precision digit (amounts carry at most 8 decimals).
  // Guard: once |scaled| >= 1e15 the 15-sig-digit snap would ROUND the last
  // displayed decimal instead of merely clearing dust (e.g. an 8-decimal
  // balance >= 1e7 units could display a hair HIGH — violating floor). Above
  // that magnitude a double can't faithfully carry those decimals anyway, so
  // bare trunc loses nothing new.
  const raw = numValue * factor
  const scaled = Math.abs(raw) < 1e15 ? Number(raw.toPrecision(15)) : raw
  const result = Math.trunc(scaled) / factor

  return result
}
